"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductInventoryEventActions = exports.EventTypes = void 0;
var EventTypes;
(function (EventTypes) {
    EventTypes["ProductInventoryEvent"] = "ProductInventoryEvent";
})(EventTypes = exports.EventTypes || (exports.EventTypes = {}));
var ProductInventoryEventActions;
(function (ProductInventoryEventActions) {
    ProductInventoryEventActions["ProductInventoryCreated"] = "ProductInventoryCreated";
    ProductInventoryEventActions["ProductInventoryUpdated"] = "ProductInventoryUpdated";
    ProductInventoryEventActions["ProductInventoryDeleted"] = "ProductInventoryDeleted";
    ProductInventoryEventActions["CreateProductInventory"] = "CreateProductInventory";
    ProductInventoryEventActions["UpdateProductInventory"] = "UpdateProductInventory";
    ProductInventoryEventActions["DeleteProductInventory"] = "DeleteProductInventory";
})(ProductInventoryEventActions = exports.ProductInventoryEventActions || (exports.ProductInventoryEventActions = {}));
